import { z } from "zod"
import { UpdateGroupRoleDtoSchema } from "@mimber/schema"

/**
 * Form schema for updating a group role
 */
export const updateGroupRoleSchema = UpdateGroupRoleDtoSchema.extend({
  description: z
    .string()
    .max(1000, "Description must be less than 1000 characters")
    .optional()
    .or(z.literal(""))
    .transform((val) => (val === "" ? undefined : val)),
})

/**
 * Output type - this is what gets passed to onSubmit
 */
export type UpdateGroupRoleData = z.output<typeof updateGroupRoleSchema>
